module.exports = __webpack_public_path__ + "img/SGP.e5181a3.svg";